import { memo, useEffect, useMemo, useState } from 'react';
import { Box, styled, Button as MuiButton, Collapse, Typography } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { CallActionBox } from './call-styles';
import { usePhoneWarnings } from '../../hooks/use-phone/use-phone-warning';
import { useCallIdentity } from '../../hooks/use-call-identity';
import { formatUSPhoneNumber } from '../../utils/formatter';
import React from 'react';
import { Contact, useContact } from '@revenuewell/logic-contact';

const ExpandButton = styled(MuiButton)({
    fontSize: 24,
    padding: '14px 0 6px'
});

const ContactInfo = styled(Box)({
    marginTop: 24,
    marginBottom: 48,
    color: '#FFF'
});

const ContactName = styled(Typography)({
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: 14,
    fontWeight: 500
});

const ContactPhoneNumber = styled(Typography)({
    marginTop: 8,
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 400
});

function CallWarningActions(props: { phoneNumber: string }) {
    const { showActions, toggleActions } = usePhoneWarnings();
    const { getContactDetailsById } = useContact();
    const { contactNames, contacts } = useCallIdentity({ phoneNumber: props.phoneNumber });
    const [contactInfo, setContactInfo] = useState<Contact>()
    const formattedPhoneNumber = useMemo(() => formatUSPhoneNumber(props.phoneNumber), [props.phoneNumber]);

    useEffect(() => {
        if (contacts && contacts[0]) {
            getContactDetailsById(contacts[0].id)
                .then(contact => setContactInfo(contact))
                .catch(error => console.error("Unable to load contact info: ", error))
        }
    }, [contacts, getContactDetailsById]);

    const type = useMemo(() => {
        if (formatUSPhoneNumber(contactInfo?.cellPhone || '') === formattedPhoneNumber) {
            return ' - Cell';
        }

        if (formatUSPhoneNumber(contactInfo?.homePhone || '') === formattedPhoneNumber) {
            return ' - Home';
        }

        if (formatUSPhoneNumber(contactInfo?.workPhone || '') === formattedPhoneNumber) {
            return ' - Work';
        }

        return '';
    }, [contactInfo, formattedPhoneNumber]);

    return (
        <div data-testid='call-warning-action-container-div'>
            <ExpandButton fullWidth onClick={toggleActions}>
                {!showActions ? <ExpandMore /> : <ExpandLess />}
            </ExpandButton>
            <Collapse in={showActions}>
                <CallActionBox>
                    <ContactInfo>
                        {contactNames && (
                            <ContactName>
                                {contactNames}
                                {type}
                            </ContactName>
                        )}
                        <ContactPhoneNumber>{formattedPhoneNumber}</ContactPhoneNumber>
                    </ContactInfo>
                </CallActionBox>
            </Collapse>
        </div>
    );
}

export default memo(CallWarningActions);
